const t = "대화상자 창", o = "닫기", e = {
  title: t,
  close: o
};
export {
  o as close,
  e as default,
  t as title
};
